import { createBrowserRouter } from "react-router-dom";
import PersistLogin from "./components/persistLogin";
import RequireAuth from "./components/requireAuth";
import Home from "../pages/Home";
import Login from "../pages/auth/Login";
import Register from "../pages/auth/Register";
import RegistrationStatus from "../components/auth/RegistrationStatus";
import MainLayout from "../layouts/MainLayout";
import CompleteRegistration from "../pages/auth/CompleteRegistration";
import ForgotPassword from "../pages/auth/ForgotPassword";
import ResetPassword from "../pages/auth/ResetPassword";
import DashboardLayout from "../layouts/DashboardLayout";
import ManageDrivers from "../pages/ManageDrivers";
import ManageVehicles from "../pages/ManageVehicles";
import MakeBooking from "../pages/MakeBooking";
import ManageBookings from "../pages/ManageBookings";
import Contacts from "../pages/Contacts";

const router = createBrowserRouter([
  {
    path: "/",
    element: <MainLayout />,
    children: [
      {
        path: "/",
        element: <PersistLogin />,
        children: [
          {
            path: "/",
            element: <RequireAuth />,
            children: [
              {
                path: "/",
                element: <DashboardLayout />,
                children: [
                  { path: "/", element: <Home /> },
                  { path: "/drivers", element: <ManageDrivers /> },
                  { path: "/vehicles", element: <ManageVehicles /> },
                  { path: "/make-booking", element: <MakeBooking /> },
                  { path: "/bookings", element: <ManageBookings /> },
                  { path: "/contacts", element: <Contacts /> },
                ],
              },
            ],
          },
          { path: "/auth/login", element: <Login /> },
          { path: "/auth/register", element: <Register /> },
          {
            path: "/auth/registration-status",
            element: <RegistrationStatus />,
          },
          { path: "/auth/forgot-password", element: <ForgotPassword /> },
          { path: "/auth/reset-password", element: <ResetPassword /> },
        ],
      },
      { path: "auth/complete-registration", element: <CompleteRegistration /> },
    ],
  },
]);

export default router;
